import React, { Component } from "react";

import _ from "i18n";
import styles from "./PageHeader.local.scss";
import { ArrowLeftIcon } from "../Icons";
import { Button } from "antd";

export default class SettingPageHeader extends Component {
  render() {
    const { title, name } = this.props;

    return (
      <div className={styles.setting_page_header}>
        {this.props.onBack && (
          <Button
            key="cancel"
            style={{
              height: 36,
              width: 116,
              marginRight: 5,
              alignItems: "center",
              color: "#6D7F92",
              background: "#F8F9FA",
              display: "flex",
              textAlign: "center",
              justifyContent: "space-around",
              border: "1px solid #B2BCC6",
              boxSizing: "border-box",
              borderRadius: "5px"
            }}
            onClick={this.props.onBack}
          >
            <ArrowLeftIcon className={styles.setting_page_header_icon} />
            <div className={styles.setting_page_header_button_label}>
              {_("goBack")}
            </div>
          </Button>
        )}
        <span className={styles.setting_page_header_title}>{_(title)} </span>
        <span className={styles.setting_page_header_name}>{name}</span>
        {this.props.customAddOn}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/PageHeader/SettingPageHeader.js